import { BACKEND_BASE_URL } from "../config/environment";

export const registrarPostulante = async (data) => {
  try {
    const jsonFormulario = JSON.stringify(data);
    const backEndURL = `${BACKEND_BASE_URL}/app/RegistroPostulante/Agregar`;
    const response = await fetch(backEndURL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: jsonFormulario,
    });
    return await response.json();
  } catch (error) {
    console.error(error);
  }
};
export const inicializarFormulario = async () => {
  try {
    const backEndURL = `${BACKEND_BASE_URL}/app/RegistroPostulante/Inicializar`;
    const response = await fetch(backEndURL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    });
    return await response.json();
  } catch (error) {
    console.error(error);
  }
};
export const getUbigeo = async () => {
  try {
    const backEndURL = `${BACKEND_BASE_URL}/app/RegistroPostulante/Ubigeo`;
    const response = await fetch(backEndURL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    });
    return await response.json();
  } catch (error) {
    console.error(error);
  }
};
